import React from 'react'

import BaseModal from '../../../molecules/ChatModals/BaseModal'
import ModalTextField from '../../../atoms/ModalTextField'
import EndControls from '../EndControls'

import { formatSessionForPut } from '../../../../utilities'
import { updateSession } from '../../../../lib/api'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useAppDispatch } from '../../../../hooks/redux'
import { AddErrorAlert } from '../../../../slices/alert'
import useStyles from './styles'

const RenameConversationModal = ({ open, onClose }) => {
  const dispatch = useAppDispatch()
  const { conversation } = useQueueState()

  React.useEffect(() => {
    if (conversation?.name === 'Guest') {
      setName('')
    } else if (conversation?.name) {
      setName(conversation.name)
    } else {
      setName('')
    }
  }, [conversation])

  const [name, setName] = React.useState('')

  const current = React.useMemo(() => formatSessionForPut(conversation), [
    conversation
  ])

  const classes = useStyles()

  const handleChangeName = React.useCallback(() => {
    const newName = name || null
    const newSession = {
      ...current,
      name: newName,
      assigned_to: current.assigned_to ?? null
    }
    const { id, ...rest } = newSession

    // removing array of user ids
    delete rest.userIds
    delete rest.verified

    updateSession(id, rest)
      .then(() => onClose())
      .catch(err => {
        console.error('Error changing name', err)
        dispatch(AddErrorAlert({ err }))
      })
  }, [current, name, onClose, dispatch])

  return (
    open && (
      <>
        <BaseModal
          open={open}
          onClose={onClose}
          title='Rename Conversation'
          PaperProps={{ style: { top: '53%', width: '50%' } }}
        >
          <div className={classes.root}>
            <ModalTextField title='Name' className={classes.input}>
              <input
                placeholder='Set a name for this conversation'
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </ModalTextField>
          </div>

          <EndControls
            onSubmit={handleChangeName}
            submitText='CHANGE'
            showExtraIcons={false}
            SubmitIcon={() => null}
          />
        </BaseModal>
      </>
    )
  )
}

export default RenameConversationModal
